export default {
    OPEN_STATIC: 'OPEN_STATIC',
    CLOSED: 'CLOSED',
};
